module.exports = __webpack_public_path__ + "static/media/Nordstrom-SSO-FAQ.9c8a69fe.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/Nordstrom-SSO-FAQ.pdf
// module id = 1042
// module chunks = 2